export const MOVERS_MAKERS_REQUEST = 'MOVERS_MAKERS_REQUEST';
export const MOVERS_MAKERS_SUCCESS = 'MOVERS_MAKERS_SUCCESS';
export const MOVERS_MAKERS_FAILURE = 'MOVERS_MAKERS_FAILURE';
export const MOVERS_MAKERS_SHOW_MORE = 'MOVERS_MAKERS_SHOW_MORE';
export const MOVERS_MAKERS_SHOW_PER_ROW = 3;
export const MOVERS_MAKERS_NEXT_TEXT =
    'Load More Products';

export const MOVERS_MAKERS_TITLE = 'Trending Technologies';
